import { render, staticRenderFns } from "./CrashCourses.vue?vue&type=template&id=4bbd0993&"
import script from "./CrashCourses.vue?vue&type=script&lang=js&"
export * from "./CrashCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports